import React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { TIME_GUTTER_REM, rem } from "./gridHelpers";

// Sticky header row: pins to the top of the grid's own scroller while the body
// scrolls vertically, and scrolls horizontally in step with the columns. The
// corner spacer pins left so it always covers the time rail.
// Column cells render either a day (topLabel + mainLabel + subLabel, highlight
// = today) or an entity (initials avatar + name).
function ColumnHeaderRow({ columns, columnMinWidthRem }) {
  return (
    <Box sx={{ display: "flex", borderBottom: 1, borderColor: "divider", position: "sticky", top: 0, bgcolor: "background.paper", zIndex: 2 }}>
      <Box sx={{ width: rem(TIME_GUTTER_REM), flexShrink: 0, position: "sticky", left: 0, bgcolor: "background.paper", zIndex: 3 }} />
      {columns.map((col) => (
        <Box
          key={col.key}
          sx={{
            flex: 1,
            minWidth: rem(columnMinWidthRem),
            textAlign: "center",
            py: 0.75,
            px: 0.5,
            borderLeft: 1,
            borderColor: "divider",
            bgcolor: col.highlight ? "primary.main" : "transparent",
            color: col.highlight ? "primary.contrastText" : "text.primary",
            overflow: "hidden"
          }}
        >
          {col.avatar ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: { xs: 0.125, sm: 0.25 }, minWidth: 0, my: { xs: -0.25, sm: 0 } }}>
              <Avatar
                sx={{
                  width: { xs: "1.25rem", sm: "1.5rem" },
                  height: { xs: "1.25rem", sm: "1.5rem" },
                  fontSize: { xs: "0.5625rem", sm: "0.6875rem" },
                  bgcolor: col.avatar.backgroundColor || "primary.main"
                }}>
                {col.avatar.initials || (col.mainLabel || "?").slice(0, 2).toUpperCase()}
              </Avatar>
              <Typography noWrap sx={{ fontSize: { xs: "0.75rem", sm: "0.8125rem" }, fontWeight: 600, lineHeight: 1.3, maxWidth: "100%" }}>
                {col.mainLabel}
              </Typography>
            </Box>
          ) : (
            <>
              {col.topLabel ? <Typography sx={{ fontSize: "0.75rem", textTransform: "uppercase", opacity: 0.85 }}>{col.topLabel}</Typography> : null}
              <Typography noWrap sx={{ fontSize: "1rem", fontWeight: 700 }}>
                {col.mainLabel}
              </Typography>
              {col.subLabel ? (
                <Typography sx={{ fontSize: "0.55rem", fontWeight: 700, textTransform: "uppercase", opacity: 0.7, lineHeight: 1 }}>
                  {col.subLabel}
                </Typography>
              ) : null}
            </>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default ColumnHeaderRow;
